import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import IntakeFormPage from './IntakeFormPage.js';

export default WithGASetup(IntakeFormPage, AuthContext);
